export default __webpack_public_path__ + "static/media/contato_e_redes_sociais.468b3490.svg";